import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';

const parseValue = (value) => {
  if (typeof value === "number") return value;

  if (typeof value === "string") {
    if (value.includes("/")) {
      const [num, den] = value.split("/").map(Number);
      return den === 0 ? 0 : num / den;
    }

    if (value.includes("%")) {
      const numberPart = parseFloat(value.replace("%", ""));
      return isNaN(numberPart) ? 0 : numberPart;
    }

    const numeric = parseFloat(value);
    return isNaN(numeric) ? 0 : numeric;
  }

  return 0;
};

const CounterComponent = ({ endValue }) => {
  const isFraction = typeof endValue === "string" && endValue.includes('/');
  const isPercentage = typeof endValue === "string" && endValue.includes('%');

  const [showRawValue, setShowRawValue] = useState(false);
  const numericValue = parseValue(endValue);

  const props = useSpring({
    from: { number: 0 },
    to: { number: isFraction || isPercentage ? 1 : numericValue },
    config: { duration: 500 },
    onRest: () => {
      if (isFraction || isPercentage) {
        setShowRawValue(true);
      }
    }
  });

  return (
    <animated.div style={{ fontWeight: 'bold' }}>
      {isFraction || isPercentage
        ? showRawValue
          ? endValue
          : props.number.to(n => n.toFixed(2))
        : props.number.to(n => Math.floor(n))}
    </animated.div>
  );
};

export default CounterComponent;
